<div class="lum-c-invoice-bulk-create-dialog">
  <h2 mat-dialog-title>
    <div class="flex justify-space-between">
      <div>
        {{ title }}
      </div>
      <button
        mat-icon-button
        class="close-button"
        (click)="close()"
        [disabled]="loading"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </h2>

  <mat-dialog-content>
    <!-- Processable Items -->
    <div *ngIf="actionable.length">
      <h5>Ready for {{ actionLabel }}</h5>
      <table class="table table-striped">
        <thead>
        <tr>
          <th *ngFor="let col of columns; trackBy: trackByObjectKey">{{ col.header }}</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of actionable; trackBy: trackById">
          <td *ngFor="let col of columns; trackBy: trackByObjectKey">
            {{
              col.formatter
                ? col.formatter(item)
                : item[col.key]
            }}
          </td>
          <td>
            <ng-container [ngSwitch]="statuses.get(item[idKey])">
              <span *ngSwitchCase="batchStatus.PROCESSING">
                Processing <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span *ngSwitchCase="batchStatus.FAILED" class="text-danger">
                FAILED
              </span>
              <span *ngSwitchCase="batchStatus.COMPLETED" class="text-success">
                COMPLETED
              </span>
            </ng-container>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <h6 *ngIf="!actionable.length" class="text-danger">
      No items ready for {{ actionLabel | lowercase }}
    </h6>

    <!-- Unprocessable Items -->
    <div *ngIf="unprocessable.length">
      <mat-divider class="my-3"></mat-divider>
      <h6 class="text-warning">
        These items can’t be processed due to errors:
      </h6>
      <table class="table table-striped">
        <thead>
        <tr>
          <th *ngFor="let col of columns; trackBy: trackByObjectKey">{{ col.header }}</th>
          <th>Errors</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of unprocessable; trackBy: trackById">
          <td *ngFor="let col of columns; trackBy: trackByObjectKey">
            {{
              col.formatter
                ? col.formatter(item)
                : item[col.key]
            }}
          </td>
          <td>
            <div *ngIf="errorKey">
              {{ (item[errorKey]).join('; ') }}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <ng-container *ngIf="actionable.length">
      <mat-divider></mat-divider>
      <div class="flex justify-content-end action text-right mt-3">
        <button mat-button (click)="close()" [disabled]="loading">Close</button>
        <button
          class="flex"
          mat-raised-button
          color="primary"
          (click)="createAll()"
          [disabled]="loading || !actionable.length || allProcessed"
        >
          <div class="flex align-center gap-3">
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
            <span *ngIf="!loading">{{ actionLabel }}</span>
            <span *ngIf="loading">{{ actionLabel }} in progress…</span>
          </div>
        </button>
      </div>
    </ng-container>
  </mat-dialog-content>
</div>
